import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardBuilder from "client_config/DashboardBuilder";

export default function Dashboard(props) {
  let dashboards = [{ name: "PPC: Overall", id: 0, dashboardOrder: props.ppc_section.dashboard_order }];
  const campaignGroups = {
    search: props.search_section.campaign_groups,
    social: props.social_section.campaign_groups,
    display: props.display_section.campaign_groups,
    video: props.video_section.campaign_groups,
  };
  const performanceByChannel = {
    search: props.search_section.enabled,
    social: props.social_section.enabled,
    display: props.display_section.enabled,
    video: props.video_section.enabled,
  };
  if (props.onboarding && props.ppcDashboard) {
    dashboards = props.ppcDashboard;
  }
  const subServiceDashboards = {
    search: props.search_section.dashboard_order,
    social: props.social_section.dashboard_order,
    display: props.display_section.dashboard_order,
    video: props.video_section.dashboard_order,
  };
  return (
    <>
      <Container fluid className="p-3">
        <Row>
          <Col>
            <div className="px-lg-5 pt-5 pr-0">
              <p className="f18 visby-bold text-info pb-4">Dashboard modules:</p>
            </div>
            <div></div>
          </Col>
        </Row>
        <Row>
          <Col>
            {dashboards.map((dashboard, index) => {
              return (
                <div key={index}>
                  <DashboardBuilder
                    service="ppc"
                    ppcSection={props.ppc_section}
                    searchEnabled={props.search_section.enabled}
                    socialEnabled={props.social_section.enabled}
                    videoEnabled={props.video_section.enabled}
                    displayEnabled={props.display_section.enabled}
                    enabledServices={props.enabled_services}
                    dashboard={dashboard}
                    accountType={props.client_account.account_type}
                    campaignGroups={campaignGroups}
                    performanceByChannel={performanceByChannel}
                    onboarding={props.onboarding}
                    dashboards={dashboards}
                    setDashboard={props.setPpcDashboard}
                    currentDashboard={index}
                    subServiceDashboards={subServiceDashboards}
                  />
                </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </>
  );
}
